import React, { useState } from "react";

const Modal = ({
  OpenStyler,
  children,
  width = "80vw",
  title,
  direction = "left",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      {OpenStyler ? (
        <div onClick={toggleModal} className="cursor-pointer">{OpenStyler}</div>
      ) : (
        <button
          onClick={toggleModal}
          className="block text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
        >
          Toggle modal
        </button>
      )}

      {isOpen && (
        <>
          <div
            id="modal-overlay"
            className="fixed top-0 left-0 z-50 w-screen h-screen bg-black bg-opacity-50"
            onClick={toggleModal}
          />
          <div
            style={{ width: width }}
            id="crud-modal"
            className={`fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white p-4 rounded-lg shadow-lg dark:bg-gray-700 width-[${width}]`}
          >
            <div className="relative">
              <div
                className={`${title ? "flex" : "hidden"} ${
                  direction === "left" ? "flex-row" : "flex-row-reverse"
                } items-center justify-between p-4 border-b rounded-t dark:border-gray-600`}
              >
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  {title  ? title : ""}
                </h3>
                <div>
                  <button
                    type="button"
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                    onClick={toggleModal}
                  >
                    <svg
                      className="w-3 h-3"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 14"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                      />
                    </svg>
                    <span className="sr-only">Close modal</span>
                  </button>
                </div>
              </div>


              <div className={title ? "hidden" : "flex"}>
                  <button
                    type="button"
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                    onClick={toggleModal}
                  >
                    <svg
                      className="w-3 h-3"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 14"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                      />
                    </svg>
                    <span className="sr-only">Close modal</span>
                  </button>
                </div>
              <div className="p-4">
                
                {children}
                
                </div>
              
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Modal;
